(function () {
  var selector = '[data-currency-estimate]';
  var supportedCurrencies = ['CHF', 'CAD', 'AUD'];
  var cacheKey = 'ruffoniCurrencyEstimates:EUR';
  var cacheTtl = 60 * 60 * 1000;
  var ratesUrl = 'https://api.frankfurter.dev/v2/rates?base=EUR&quotes=' + supportedCurrencies.join(',');

  function getEstimateElements() {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function readCachedRates() {
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(cacheKey));
      if (cached && cached.rates && Date.now() - cached.timestamp < cacheTtl) {
        return cached.rates;
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function writeCachedRates(rates) {
    try {
      window.sessionStorage.setItem(cacheKey, JSON.stringify({
        timestamp: Date.now(),
        rates: rates
      }));
    } catch (error) {
      return;
    }
  }

  function normalizeRates(payload) {
    var rates = {};

    if (Array.isArray(payload)) {
      payload.forEach(function (row) {
        if (row && row.quote && row.rate) {
          rates[row.quote] = row.rate;
        }
      });

      return rates;
    }

    return payload && payload.rates ? payload.rates : rates;
  }

  function fetchRates() {
    var cachedRates = readCachedRates();
    if (cachedRates) {
      return Promise.resolve(cachedRates);
    }

    return fetch(ratesUrl, { credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to fetch currency rates');
        }

        return response.json();
      })
      .then(function (payload) {
        var rates = normalizeRates(payload);
        writeCachedRates(rates);
        return rates;
      });
  }

  function formatCurrency(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {
      return currency + ' ' + Math.round(amount);
    }
  }

  function renderEstimates(rates) {
    getEstimateElements().forEach(function (element) {
      var currency = element.dataset.targetCurrency;
      var priceCents = parseInt(element.dataset.priceCents, 10);
      var rate = rates[currency];

      if (!currency || !rate || isNaN(priceCents)) {
        return;
      }

      var eurAmount = priceCents / 100;
      var convertedAmount = eurAmount * rate;

      element.textContent = '(approx. ' + formatCurrency(convertedAmount, currency) + ')';
      element.hidden = false;
    });
  }

  function initCurrencyEstimates() {
    if (!getEstimateElements().length) {
      return;
    }

    fetchRates()
      .then(renderEstimates)
      .catch(function () {
        return;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCurrencyEstimates);
  } else {
    initCurrencyEstimates();
  }
})();
